
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  display: inline-block;
  font-size:1.35rem
}

:host([alt]) {
  border-radius: 0.5rem;
  border-style: solid;
  border-color: var(--blue-responsible-darken-2);
  background-color: var(--blue-responsible-lighten-5);
  padding: 0.5rem;
  border-width:1px !important;
  border-color:var(--blue-responsible-lighten-2) !important
}

svg {
  display: block;
  line-height:0
}
`;